/* NIVHEX — interacciones propias (prefijo pe-) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Formato de precio ---------- */
  function formatMoney(cents, format) {
    format = format || '{{amount_with_comma_separator}} €';
    function withDelims(n, prec, thou, dec) {
      var s = (n / 100).toFixed(prec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return s[0] + (s[1] ? dec + s[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = withDelims(cents, 2, "'", '.'); break;
      default: val = withDelims(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  /* ---------- Revelado al hacer scroll ---------- */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.pe-reveal:not(.pe-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pe-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pe-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-pe-parallax]');
    if (!els.length || reduceMotion) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        if (window.innerWidth < 990) { el.style.transform = ''; return; }
        var r = el.getBoundingClientRect();
        var intensidad = parseFloat(el.getAttribute('data-pe-parallax')) || 0;
        var progreso = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (progreso * intensidad * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Formulario de compra con tallas ---------- */
  function initCompra(root) {
    if (root.dataset.peListo) return;
    root.dataset.peListo = '1';
    var dataEl = root.querySelector('[data-pe-variantes]');
    if (!dataEl) return;
    var variantes = JSON.parse(dataEl.textContent);
    var formato = root.getAttribute('data-pe-formato');
    var textos = {
      anadir: root.getAttribute('data-pe-txt-anadir'),
      agotado: root.getAttribute('data-pe-txt-agotado'),
      noDisponible: root.getAttribute('data-pe-txt-nodisponible')
    };
    var inputId = root.querySelector('input[name="id"]');
    var boton = root.querySelector('[data-pe-boton]');
    var botonTxt = boton ? boton.querySelector('span') : null;
    var precio = root.querySelectorAll('[data-pe-precio]');
    var antes = root.querySelectorAll('[data-pe-precio-antes]');
    var ahorro = root.querySelectorAll('[data-pe-ahorro]');
    var etiquetas = root.querySelectorAll('[data-pe-opcion-elegida]');
    var actualizarUrl = root.getAttribute('data-pe-url') === 'true';

    function seleccion() {
      var sel = [];
      root.querySelectorAll('.pe-opcion').forEach(function (fs, i) {
        var c = fs.querySelector('input:checked');
        sel[i] = c ? c.value : null;
        var lab = fs.querySelector('[data-pe-opcion-elegida]');
        if (lab && c) lab.textContent = c.value;
      });
      return sel;
    }

    function marcarAgotados(sel) {
      root.querySelectorAll('.pe-opcion').forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var prueba = sel.slice(); prueba[i] = inp.value;
          var v = variantes.find(function (x) { return x.options.every(function (o, j) { return prueba[j] == null || o === prueba[j]; }); });
          inp.classList.toggle('pe-agotado', !v || !v.available);
        });
      });
    }

    function cambiar() {
      var sel = seleccion();
      var v = variantes.find(function (x) { return x.options.every(function (o, j) { return o === sel[j]; }); });
      marcarAgotados(sel);
      if (!v) {
        if (boton) { boton.setAttribute('disabled', 'disabled'); if (botonTxt) botonTxt.textContent = textos.noDisponible; }
        return;
      }
      if (inputId) inputId.value = v.id;
      precio.forEach(function (el) { el.textContent = formatMoney(v.price, formato); });
      var rebajado = v.compare_at_price && v.compare_at_price > v.price;
      antes.forEach(function (el) { el.hidden = !rebajado; if (rebajado) el.textContent = formatMoney(v.compare_at_price, formato); });
      ahorro.forEach(function (el) {
        el.hidden = !rebajado;
        if (rebajado) el.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
      });
      if (boton) {
        if (v.available) { boton.removeAttribute('disabled'); if (botonTxt) botonTxt.textContent = textos.anadir; }
        else { boton.setAttribute('disabled', 'disabled'); if (botonTxt) botonTxt.textContent = textos.agotado; }
      }
      if (actualizarUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('pe:variante', { detail: { variante: v, root: root } }));
    }

    root.querySelectorAll('.pe-opcion input').forEach(function (inp) { inp.addEventListener('change', cambiar); });
    marcarAgotados(seleccion());

    /* cantidad */
    var cant = root.querySelector('[data-pe-cantidad]');
    if (cant) {
      var input = cant.querySelector('input');
      cant.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-paso'), 10);
          input.value = Math.max(1, Math.min(99, n));
        });
      });
    }
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(g) {
    if (g.dataset.peListo) return;
    g.dataset.peListo = '1';
    var principal = g.querySelector('[data-pe-principal]');
    var minis = Array.prototype.slice.call(g.querySelectorAll('[data-pe-mini]'));
    if (!principal || !minis.length) return;
    var actual = 0;
    function ir(i) {
      if (i < 0) i = minis.length - 1;
      if (i >= minis.length) i = 0;
      if (i === actual && principal.getAttribute('src')) return;
      actual = i;
      var m = minis[i];
      principal.classList.add('pe-cambiando');
      setTimeout(function () {
        principal.src = m.getAttribute('data-src');
        principal.srcset = m.getAttribute('data-srcset') || '';
        principal.alt = m.getAttribute('data-alt') || '';
        principal.onload = function () { principal.classList.remove('pe-cambiando'); };
        setTimeout(function () { principal.classList.remove('pe-cambiando'); }, 400);
      }, 150);
      minis.forEach(function (x, j) { x.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
    var prev = g.querySelector('[data-pe-prev]');
    var next = g.querySelector('[data-pe-next]');
    if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
    if (next) next.addEventListener('click', function () { ir(actual + 1); });

    /* deslizar con el dedo */
    var x0 = null;
    principal.parentNode.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    principal.parentNode.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    document.addEventListener('pe:variante', function (e) {
      var v = e.detail.variante;
      if (!v.featured_media) return;
      var idx = minis.findIndex(function (m) { return m.getAttribute('data-media-id') == v.featured_media.id; });
      if (idx > -1) ir(idx);
    });
  }

  /* ---------- Barra fija de compra ---------- */
  function initBarra() {
    var barra = document.querySelector('[data-pe-barra]');
    var objetivo = document.querySelector('[data-pe-observar]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('pe-visible', pasado);
      });
    });
    io.observe(objetivo);
    var btn = barra.querySelector('[data-pe-barra-boton]');
    if (btn) {
      btn.addEventListener('click', function () {
        var form = document.getElementById(btn.getAttribute('data-form'));
        if (!form) return;
        var submit = form.querySelector('[type="submit"]');
        if (submit && !submit.disabled) {
          if (form.requestSubmit) form.requestSubmit(); else submit.click();
        } else {
          objetivo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
    document.addEventListener('pe:variante', function (e) {
      var p = barra.querySelector('[data-pe-barra-precio]');
      if (p) p.textContent = formatMoney(e.detail.variante.price, e.detail.root.getAttribute('data-pe-formato'));
    });
  }

  /* ---------- Enlaces internos con desplazamiento suave ---------- */
  function initAnclas() {
    document.querySelectorAll('.pe-section a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var t = document.querySelector(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initTodo(scope) {
    initReveal(scope);
    (scope || document).querySelectorAll('[data-pe-compra]').forEach(initCompra);
    (scope || document).querySelectorAll('[data-pe-galeria]').forEach(initGaleria);
  }

  function arrancar() {
    window.peReady = true;
    initTodo();
    initParallax();
    initBarra();
    initAnclas();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  /* Editor de Shopify: re-inicializar al cambiar ajustes */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.pe-reveal').forEach(function (el) { el.classList.add('pe-visible'); });
    initTodo(e.target);
  });
})();
